import $ from "@modules/jquery";

$(document).ready(function() {
    $(".not-clickable a").each(function(){
        $(this).css('cursor', 'default');
        $(this).removeAttr("href");
    });

    window.onscroll = function() {
        if ((window.innerHeight + Math.ceil(window.pageYOffset)) >= document.body.offsetHeight) {
        $('.back-to-top').css('bottom', '7rem');
        }
        if ((window.innerHeight + Math.ceil(window.pageYOffset)) <= document.body.offsetHeight) {
          $('.back-to-top').css('bottom', '2rem');
        }
      }
});
